export const SET_EDITOR_COMPONENTS = 'setEditorComponents'
export const UPDATE_EDITOR_COMPONENT = 'updateEditorComponent'
